/**
 * Brouillon création objet trouvé — survit au kill Chrome Android
 * (appareil photo / galerie sur Samsung, Xiaomi, etc.).
 */

export const FOUND_OBJECT_CREATE_DRAFT_KEY = 'sherlook-provider:found-object-create-draft';

export type FoundObjectCreateDraft = {
  savedAt: number;
  awaitingPhoto: boolean;
  formData: {
    title: string;
    objectType: string;
    foundAt: string;
    location: string;
    status: string;
    images: string[];
    categoryId: number | null;
    objectAttributes: Record<string, unknown>;
    locationData: Record<string, unknown>;
    provider_event_id: number | null;
  };
};

const DRAFT_MAX_AGE_MS = 2 * 60 * 60 * 1000;

export function loadFoundObjectCreateDraft(): FoundObjectCreateDraft | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(FOUND_OBJECT_CREATE_DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FoundObjectCreateDraft;
    if (!parsed?.formData || !parsed.savedAt) {
      clearFoundObjectCreateDraft();
      return null;
    }
    if (Date.now() - parsed.savedAt > DRAFT_MAX_AGE_MS) {
      clearFoundObjectCreateDraft();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveFoundObjectCreateDraft(
  formData: FoundObjectCreateDraft['formData'],
  options?: { awaitingPhoto?: boolean }
): void {
  if (typeof window === 'undefined') return;
  try {
    const prev = loadFoundObjectCreateDraft();
    const draft: FoundObjectCreateDraft = {
      savedAt: Date.now(),
      awaitingPhoto: options?.awaitingPhoto ?? prev?.awaitingPhoto ?? false,
      formData,
    };
    sessionStorage.setItem(FOUND_OBJECT_CREATE_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    /* quota / mode privé */
  }
}

export function markFoundObjectCreateDraftAwaitingPhoto(): void {
  const draft = loadFoundObjectCreateDraft();
  if (!draft) return;
  try {
    sessionStorage.setItem(
      FOUND_OBJECT_CREATE_DRAFT_KEY,
      JSON.stringify({ ...draft, awaitingPhoto: true, savedAt: Date.now() })
    );
  } catch {
    /* ignore */
  }
}

export function clearFoundObjectCreateDraftAwaitingPhoto(): void {
  const draft = loadFoundObjectCreateDraft();
  if (!draft) return;
  try {
    sessionStorage.setItem(
      FOUND_OBJECT_CREATE_DRAFT_KEY,
      JSON.stringify({ ...draft, awaitingPhoto: false, savedAt: Date.now() })
    );
  } catch {
    /* ignore */
  }
}

export function clearFoundObjectCreateDraft(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(FOUND_OBJECT_CREATE_DRAFT_KEY);
  } catch {
    /* ignore */
  }
}

/** Brouillon à restaurer après kill navigateur (surtout pendant prise de photo). */
export function shouldRestoreFoundObjectCreateDraft(): boolean {
  const draft = loadFoundObjectCreateDraft();
  if (!draft) return false;
  if (draft.awaitingPhoto) return true;
  const f = draft.formData;
  return (
    (Array.isArray(f.images) && f.images.length > 0) ||
    f.categoryId != null ||
    Object.keys(f.objectAttributes || {}).length > 0
  );
}
